export default __webpack_public_path__ + "images/dffde23be78bc138b4d07d3d74e71b89.svg";